"use strict";

import Vue from 'vue';
import axios from "axios";
import { parseDomain } from 'parse-domain';


// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
const AUTH_TOKEN = localStorage.getItem('token')
if(AUTH_TOKEN){
  axios.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;
}
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let serviceUrl = process.env.VUE_APP_BASE_URL || process.env.apiUrl || "";
if(process.env.NODE_ENV != 'development'){
  const parseResult = parseDomain(window.location.hostname);
  const { domain, topLevelDomains } = parseResult;
  const topLevel = topLevelDomains.join('.');
  serviceUrl = `https://services.${domain}.${topLevel}`;
}

let config = {
  baseURL: serviceUrl,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // allow credentials to be send, including cookies in the request header
  crossorigin: true
};

const _axios = axios.create(config);


Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
